import axios from 'axios'
import { cloneDeep } from 'lodash'

/**
 * @param {*} data
 * @param {*} old
 * @param {*} attribute
 */
const renameKey = (data, old, attribute) => {
  delete Object.assign(data, {[attribute]: data[old]})[old]
}

/**
 * @param {*} data
 * @param {*} type
 */
const generatePerson = (data, type = 'sender') => {
  if (data[type].hasOwnProperty('address')) {
    let address = data[type].address

    delete data[type].address

    renameKey(address, 'name', 'address')
    renameKey(address, 'notes', 'note')

    delete address.country

    return Object.assign(data[type], address)
  }
}

/**
 * @param {*} products
 */
const generateProducts = products => {
  return products.map(product => {
    return {
      name: product.name,
      quantity: product.quantity,
      unitary_value: product.price
    }
  })
}

/**
 * Deprecated
 *
 * @param {*} volume
 */
const generatePackage = volume => {
  return {
    weight: volume.weight,
    width: volume.width,
    height: volume.height,
    length: volume.length
  }
}

/**
 * @param {*} sale
 */
const generatePayload = sale => {
  let payload = {
    sale_id: sale.id,
    service: sale.cotation.id,
    from: generatePerson(sale),
    to: generatePerson(sale, 'receiver'),
    products: generateProducts(sale.products),
    volumes: sale.cotation.volumes,
    options: {
      insurance_value: sale.amount.subtotal,
      receipt: !!(sale.options.receipt),
      own_hand: !!(sale.options.own_hand),
      collect: !!(sale.options.collect),
      reverse: !!(sale.options.reverse),
      non_commercial: !!(sale.options.non_commercial),
      invoice: {
        number: sale.invoice.number,
        key: sale.invoice.key
      },
      reminder: sale.options.reminder
    },
    cotation: sale.cotation
  }

  if ((payload.service === 3 || payload.service === 4)) {
    if (isNaN(parseInt(sale.options.agency))) {
      return false
    }

    Object.assign(payload, {agency: sale.options.agency})
  }

  return payload
}

/**
 * @param {*} responses
 */
export const redirectToCheckout = responses => {
  let form = document.createElement('form');

  form.method = 'POST';

  form.action = '/checkout';

  let token = document.createElement('input');

  token.type = 'hidden';

  token.name = '_token';

  token.value = MEConfig.get('csrf-token');

  form.appendChild(token);

  for (let i = 0; i < responses.length; i++) {
    let response = responses[i];

    if (response.data && response.data.id) {
      let input = document.createElement('input');

      input.type  = 'hidden';

      input.name  = 'orders[]';

      input.value = response.data.id;

      window.$me_nav('increment-cart');

      form.appendChild(input);
    }
  }

  document.body.appendChild(form);

  form.submit();
}

/**
 * @param {*} content
 */
export const addToCart = (content) => {
  let data = cloneDeep(content)

  let payload = generatePayload(data)

  if (payload) {
    return axios.post(`/api/v2/me/cart`, payload, {
      headers: {
        'ME-BUY-ORIGIN': 'dashboard',
        'ME-BUY-TYPE': 'sales',
        'ME-BUY-NOW': true,
        'ME-BUY-SPREADSHEETS': false,
        'x-minhas-vendas': true
      }
    })
  }

  alert('Um erro ocorreu')
}
